<template>
  <div class="flex flex-col gap-2 mb-2 h-max">
    <span class="text-start px-2 rounded"> כדי להתחבר צריך מספר מזהה API. התחברו לחשבון ה-EzCount שברשותכם, היכנסו להגדרות, ולחצו על API.</span>
    <p class="text-sm bg-blue-100 p-4 rounded mt-2">
      <strong>שימו ❤️</strong>
      אם יש לכם חבילה של Hyp, יש לעבור אל האתר של EzCount דרך המערכת של Hyp.
    </p>

    <div class="w-full mt-6">
      <Button
        label="הבא"
        class="w-full"
        style="display: flex; flex-grow: 1"
        @click="$emit('next')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">

import { useToast } from 'vue-toastification';

defineEmits(['next']);

const toast = useToast();

</script>

<style scoped lang="scss">

</style>
